<template>
  <div class="search-template--no-results">
    <div class="search-app__input-group desktop-hide no-border">
      <SearchBar @termChange="onTermChange" />
    </div>
    <div class="container">
      <div class="section-header">
        <h2 v-html="noResultMessage" />
        <p v-html="emptySearchMessage" />
        <div class="search-app__input-group mobile-hide no-border">
          <SearchBar @termChange="onTermChange" />
        </div>
        <div class="popular-linklist" />
        <p v-html="showingNoResult" />
      </div>
    </div>
  </div>
</template>
<script>
import SearchBar from '~legacy-vue/vueComponents/SearchModal/SearchBar.vue'
export default {
  name: 'NoResult',
  components: {
    SearchBar,
  },
  props: [],
  data: function() {
    return {
      noResultMessage: '',
      emptySearchMessage: '',
      showingNoResult: '',

    }
  },
  created() {
    this.noResultMessage = $('body').find('[data-no-result-message]').attr('data-no-result-message')
    this.emptySearchMessage = $('body').find('[data-empty-search-message]').attr('data-empty-search-message')
    this.showingNoResult = $('body').find('[data-showing-no-result]').attr('data-showing-no-result')
  },
  mounted() {
    const importPopularLinklist = $('.outside-vue-popular-linklist').html()
    $('.popular-linklist').append(importPopularLinklist)
  },
  methods: {
    onTermChange: function (searchTerm) {
      this.searchTerm = searchTerm
      const term = searchTerm.replace(/\s/g, '')

      if (term.length == 0) {
        // this.loadSearchSuggestions('reinit', 'defaultsearch');
        this.search('defaultsearch')
        return
      }

      if (term.length % 3 === 0) {
        this.search(this.searchTerm)
      }
    },
    search: function (term) {
      const jsonpScript = document.createElement('script')
      const env = mint.services.attraqt.instance

      jsonpScript.id = 'jsonpScript'
      jsonpScript.src =
        `https://query.published.${env}.suggest.eu1.fredhopperservices.com/mint_velvet/jscript?scope=//mintvelvet/en_GB&callback=searchCallback&search=` +
        term
      document.getElementsByTagName('head')[0].appendChild(jsonpScript)
    },
  },
}
</script>
<style lang="scss">
.search-template--no-results .search-app__close {
    display: none!important;
}
.outside-vue-popular-linklist {
    display: none;
}
.popular-linklist .outside-vue-popular-linklist {
    display: block;
}
</style>